import { Grid, TextField } from "@material-ui/core";
import React, { Ref } from "react";
import { $Service, Service } from "../_generated";
import { validationFromSchema } from "../util";

export function ServiceContainerFields({
  service,
  register,
  errors,
}: {
  service?: Service;
  register: (r: any) => Ref<any>;
  errors: any;
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register(validationFromSchema($Service.properties.name))}
          label="Name"
          name="alias"
          required
          error={errors.name !== undefined}
          helperText={errors.name?.message}
          defaultValue={service ? service.alias : ""}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register}
          label="Service path"
          name="path"
          required
          defaultValue={service ? service.path : "./"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register(
            validationFromSchema($Service.properties.dockerfile)
          )}
          label="Dockerfile"
          name="dockerfile"
          required
          defaultValue={service ? service.dockerfile : "./Dockerfile"}
          error={errors.dockerfile !== undefined}
          helperText={errors.dockerfile?.message}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register(
            validationFromSchema($Service.properties.health_check)
          )}
          label="Health check"
          name="health_check"
          required
          defaultValue={service ? service.health_check : "/"}
          error={errors.health_check !== undefined}
          helperText={errors.health_check?.message}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register(
            validationFromSchema($Service.properties.container_port)
          )}
          label="Container port"
          name="container_port"
          required
          defaultValue={service ? service.container_port : "8080"}
          error={errors.container_port !== undefined}
          helperText={errors.container_port?.message}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

export function ServiceWebappFields({
  service,
  register,
  errors,
}: {
  service?: Service;
  register: (r: any) => Ref<any>;
  errors: any;
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register(validationFromSchema($Service.properties.name))}
          label="Name"
          name="alias"
          required
          error={errors.name !== undefined}
          helperText={errors.name?.message}
          defaultValue={service ? service.alias : ""}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register}
          label="Service path"
          name="service_path"
          defaultValue={service ? service.path : "./app"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register}
          label="Build directory"
          name="build_directory"
          defaultValue={service ? service.build_directory : "./app/dist"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          inputRef={register}
          label="Build Command"
          name="build_command"
          defaultValue={service ? service.build_command : "npm run build"}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
